import React, { useState, useEffect, useRef, useContext, useMemo, useCallback, useReducer } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import { useNavigate, useLocation } from "react-router-dom";
import DashboardLayout from "../../../../../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../../../../examples/Navbars/DashboardNavbar";
import Footer from "../../../../../../examples/Footer";
import { Box, Typography } from "@mui/material";
// Büyük formda her tuşta tüm formun yeniden çizilmesini önleyen tamponlu TextField (yazma gecikmesi)
import TextField from "components/BufferedTextField";
import { isValid } from "date-fns";
import { AuthContext } from "../../../../../../context/index";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import countryOptions from "../../components/List/Countries";
import { t } from "../../../../../../langs";
import CrudService from "services/cruds-service";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import {companies} from "../../companies";
import { CrmPageHeader, CrmNotice, CrmActionButton, crmCardSx } from "../shared/CrmUi";
import { ReadOnlyBanner, ReadOnlyFieldset } from "components/ReadOnlyLock";

const initialForm = {
    selectedCustomer: null,
    taxId: "",
    customerCountry: "",
    city: "",
    representatives: "",
    representativesTitle: "",
    representativesContact: "",
    webSite: "",
    industry: "",
    companySize: "",
    logisticsDecision: "",
    sourceType: "",
    shipper:"",
    consignee:"",
    globalAgentName: "",
    competitorCompanyName: "",
    sourceDetail: {
        visitPlanId: "",
        visitNoteLink: "",
        visitDate: null,
        referrerName: "",
        referrerCompany: "",
        referrerContact: "",
        agentId: "",
        agentContact: "",
        leadOwnership: "",
        socialPlatform: "",
        socialProfileLink: "",
        messageScreenshotLink: "",
        rumorTrustScore: "",
        rumorNote: "",
        walkInLocation: "",
        walkInNote: "",
    },
    contacts: [
        {
            name: "",
            role: "",
            email: "",
            phone: "",
        },
    ],
    tradeType: "",
    incoterm: "",
    laneOriginCountry: "",
    laneOriginCityOrPort: "",
    laneDestinationCountry: "",
    laneDestinationCityOrPort: "",
    commodityOrVertical: "",
    productServiceModes: [
        { serviceMode: "", projectSubtype: "", volumeEstimate: "" }
    ],
    leadStatus: "New",
    followUpPlan: "30",
    followUpCustomDays: "",
    nextActionDate: null,
    nextActionType: "",
    meetingStatus: "Planned",
    participants: [""],
    meetingPlatform: "",
    meetingNotes: "",
    recapMeetingNotes: "",
    salesRep: [],
    attendees: [],
};

function formReducer(state, action) {
    switch (action.type) {
        case "SET":
            return { ...state, [action.key]: action.value };
        case "PATCH":
            return { ...state, ...action.payload };
        case "SET_SOURCE_DETAIL":
            return { ...state, sourceDetail: { ...state.sourceDetail, ...action.payload } };
        case "RESET":
            return initialForm;
        default:
            return state;
    }
}

const safeParseDate = (dateString) => {
    if (!dateString) return null;
    try {
        const parsed = new Date(dateString);
        return isValid(parsed) ? parsed : null;
    } catch {
        return null;
    }
};

const formatDateInput = (d) => {
    if (!d) return "";
    const dt = new Date(d);
    if (!isValid(dt)) return "";
    return dt.toISOString().slice(0, 10);
};

const CreateSalesLead = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useContext(AuthContext);
    const [errors, setErrors] = useState({});
    const [snack, setSnack] = useState({ open: false, severity: "error", message: "" });

    const openSnack = useCallback((message, severity = "error") => {
        setSnack({ open: true, severity, message });
    }, []);

    const closeSnack = useCallback(() => {
        setSnack((s) => ({ ...s, open: false }));
    }, []);

    const [form, dispatch] = useReducer(formReducer, initialForm);
    const [partyType, setPartyType] = useState("Customer");
    const [customerList, setCustomerList] = useState([]);
    const [globalAgentList, setGlobalAgentList] = useState([]);
    const [salesRepOptions, setSalesRepOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const [cityLoading, setCityLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const searchParams = new URLSearchParams(location.search);
    const leadId = searchParams.get("id");
    const isEditing = Boolean(leadId);
    // An existing sales lead opens read-only, like the TMS pages; "Edit" unlocks the form.
    const [readOnlyMode, setReadOnlyMode] = useState(isEditing);
    useEffect(() => {
        setReadOnlyMode(isEditing);
    }, [isEditing, leadId]);
    const [selectedOriginCountry, setSelectedOriginCountry] = useState(null);
    const [selectedDestinationCountry, setSelectedDestinationCountry] = useState(null);
    const [originOptions, setOriginOptions] = useState([]);
    const [destinationOptions, setDestinationOptions] = useState([]);
    const [selectedOriginPlace, setSelectedOriginPlace] = useState(null);
    const [selectedDestinationPlace, setSelectedDestinationPlace] = useState(null);
    const [originInputValue, setOriginInputValue] = useState("");
    const [destinationInputValue, setDestinationInputValue] = useState("");
    const [originLoading, setOriginLoading] = useState(false);
    const [destinationLoading, setDestinationLoading] = useState(false);
    const originAbortRef = useRef(null);
    const destinationAbortRef = useRef(null);
    const [globalAgentNameOptions, setGlobalAgentNameOptions] = useState([]);
    const [competitorCompanyOptions, setCompetitorCompanyOptions] = useState([]);
    const [competitorLoading, setCompetitorLoading] = useState(false);

// Lead form state’inde tutacaksan:
    const [leadData, setLeadData] = useState({
        origin: {
            country: "",
            placeLabel: "",
            placeType: "",
            placeId: "",
            additionalInfo: "",
        },
        destination: {
            country: "",
            placeLabel: "",
            placeType: "",
            placeId: "",
            additionalInfo: "",
        },
    });

    const {
        fromVisitPlan,
        leadCompany,
        selectedCustomer,
        taxId,
        customerCountry,
        city,
        representatives,
        representativesTitle,
        representativesContact,
        webSite,
        shipper,
        consignee,
        industry,
        companySize,
        logisticsDecision,
        meetingDate,
        meetingTitle,
        salesRep,
        attendees,
        preMeetingTitle,
        preMeetingNotes,
    } = location.state || {};

    useEffect(() => {
        (async () => {
            try {
                // Global Agents (name)
                const gaRes = await CrudService.getGlobalAgents();
                const gaArr = gaRes?.data || [];
                const gaNames = gaArr
                    .map((a) => a?.attributes?.name || a?.name || "")
                    .map((s) => String(s).trim())
                    .filter(Boolean);

                setGlobalAgentNameOptions(Array.from(new Set(gaNames)).sort((a, b) => a.localeCompare(b)));

            } catch (e) {
                console.error("Global agent names fetch error:", e);
                setGlobalAgentNameOptions([]);
            }
        })();
    }, []);

    useEffect(() => {
        (async () => {
            try {
                setCompetitorLoading(true);

                // Competitors (companyName)
                const compRes = await CrudService.getCompetitors(); // ✅ bunu servisinde ekle
                const compArr = compRes?.data || [];
                const compNames = compArr
                    .map((c) => c?.attributes?.competitorCompany || c?.competitorCompany || "")
                    .map((s) => String(s).trim())
                    .filter(Boolean);

                setCompetitorCompanyOptions(Array.from(new Set(compNames)).sort((a, b) => a.localeCompare(b)));

            } catch (e) {
                console.error("Competitors fetch error:", e);
                setCompetitorCompanyOptions([]);
            } finally {
                setCompetitorLoading(false);
            }
        })();
    }, []);


    const capFirst = (s) => {
        const t = (s || "").toString().trim().toLocaleLowerCase("tr-TR");
        if (!t) return "";
        return t.charAt(0).toLocaleUpperCase("tr-TR") + t.slice(1);
    };


    useEffect(() => {
        if (!fromVisitPlan) return;
        dispatch({
            type: "PATCH",
            payload: {
                selectedCustomer: selectedCustomer || null,
                taxId: taxId || "",
                customerCountry: customerCountry || "",
                city: capFirst(typeof city === "string" ? city : (city?.label || city?.name || "")),
                representatives: representatives || "",
                representativesTitle: representativesTitle || "",
                representativesContact: representativesContact || "",
                webSite: webSite || "",
                industry: industry || "",
                shipper: shipper || "",
                consignee: consignee || "",
                companySize: companySize || "",
                logisticsDecision: logisticsDecision || "",
                meetingDate: meetingDate ? new Date(meetingDate) : null,
                meetingTitle: meetingTitle || "",
                salesRep: Array.isArray(salesRep) ? salesRep : [],
                attendees: Array.isArray(attendees) ? attendees : [],
                preMeetingTitle: preMeetingTitle || "",
                preMeetingNotes: preMeetingNotes || "",
                sourceType: "CRM Visit Plan",
                sourceDetail: {
                    ...initialForm.sourceDetail,
                    visitPlanId: leadId || "",
                    visitDate: meetingDate ? new Date(meetingDate) : null,
                },
            },
        });
        }, [fromVisitPlan]);

    const [successMessage, setSuccessMessage] = useState("");
    const successMessageRef = useRef(null);
    const [inputValue, setInputValue] = useState("");
    const [open, setOpen] = useState(false);
    const pickArray = (resp) => {
        const d = resp?.data;
        if (Array.isArray(d)) return d;
        if (Array.isArray(d?.data)) return d.data;
        return [];
    };
    const asOpt = (type, item) => {
        if (typeof item === "string") {
            const label = item.trim();
            if (!label) return null;
            const id = `${type}:${label.toLowerCase()}`;
            return { type, id, label, raw: item };
        }
        const a = item?.attributes || item;
        const label =
            a?.name ||
            a?.label ||
            a?.cityName ||
            a?.portName ||
            a?.airportName ||
            "";
        const rawId = item?.id || item?._id || a?.id || a?._id || a?.code || a?.iata || a?.name || label;
        const id = `${type}:${String(rawId).toLowerCase()}`;
        if (!label) return null;
        return { type, id, label, raw: item };
    };

    const uniqById = (arr) => {
        const m = new Map();
        arr.forEach((o) => {
            if (!o?.id) return;
            if (!m.has(o.id)) m.set(o.id, o);
        });
        return [...m.values()];
    };

    useEffect(() => {
        const country = selectedOriginCountry?.label;
        if (!country) {
            originAbortRef.current?.abort?.();
            setOriginOptions([]);
            setSelectedOriginPlace(null);
            setOriginInputValue("");
            setOriginLoading(false);
            setLeadData((p) => ({...p, origin: { ...p.origin, country: "", placeLabel: "", placeType: "", placeId: "" }}));
            return;
        }
        originAbortRef.current?.abort?.();
        const controller = new AbortController();
        originAbortRef.current = controller;
        (async () => {
            try {
                setOriginLoading(true);
                const [seaportsResp, airportsResp, citiesResp] = await Promise.all([
                    CrudService.getSeaportsByCountryOpp(country, { signal: controller.signal }),
                    CrudService.getAirportsByCountryOpp(country, { signal: controller.signal }),
                    CrudService.getCitiesByCountryOpp(country, { signal: controller.signal }),
                ]);
                const seaports = pickArray(seaportsResp).map((x) => asOpt("SEAPORT", x)).filter(Boolean);
                const airports = pickArray(airportsResp).map((x) => asOpt("AIRPORT", x)).filter(Boolean);
                const cities   = pickArray(citiesResp).map((x) => asOpt("CITY", x)).filter(Boolean);
                setOriginOptions(uniqById([...seaports, ...airports, ...cities]));
            } catch (e) {
                if (e?.name === "AbortError") return;
                setOriginOptions([]);
            } finally {
                setOriginLoading(false);
            }
        })();
        return () => controller.abort();
    }, [selectedOriginCountry?.label]);

    useEffect(() => {
        const country = selectedDestinationCountry?.label;
        if (!country) {
            destinationAbortRef.current?.abort?.();
            setDestinationOptions([]);
            setSelectedDestinationPlace(null);
            setDestinationInputValue("");
            setDestinationLoading(false);
            setLeadData((p) => ({...p, destination: { ...p.destination, country: "", placeLabel: "", placeType: "", placeId: "" }}));
            return;
        }
        destinationAbortRef.current?.abort?.();
        const controller = new AbortController();
        destinationAbortRef.current = controller;
        (async () => {
            try {
                setDestinationLoading(true);
                const [seaportsResp, airportsResp, citiesResp] = await Promise.all([
                    CrudService.getSeaportsByCountryOpp(country, { signal: controller.signal }),
                    CrudService.getAirportsByCountryOpp(country, { signal: controller.signal }),
                    CrudService.getCitiesByCountryOpp(country, { signal: controller.signal }),
                ]);
                const seaports = pickArray(seaportsResp).map((x) => asOpt("SEAPORT", x)).filter(Boolean);
                const airports = pickArray(airportsResp).map((x) => asOpt("AIRPORT", x)).filter(Boolean);
                const cities   = pickArray(citiesResp).map((x) => asOpt("CITY", x)).filter(Boolean);
                setDestinationOptions(uniqById([...seaports, ...airports, ...cities]));
            } catch (e) {
                if (e?.name === "AbortError") return;
                setDestinationOptions([]);
            } finally {
                setDestinationLoading(false);
            }
        })();
        return () => controller.abort();
    }, [selectedDestinationCountry?.label]);
    const companySizeOptions = useMemo(() => ["Small", "Mid Size", "Large", "Extra Large", "Global"], []);
    const logisticsOptions = useMemo(() => ["Export", "Import", "All"], []);
    const incotermsOptions = useMemo(
        () => [
            { label: "CFR" },
            { label: "CIF" },
            { label: "CIP" },
            { label: "CPT" },
            { label: "DAP" },
            { label: "DAT" },
            { label: "DPU" },
            { label: "DDP" },
            { label: "EXW" },
            { label: "FAS" },
            { label: "FCA" },
            { label: "FOB" },
            { label: "FOT" },
            { label: "FOR" },
        ],
        []
    );
    const sourceTypeOptions = useMemo(
        () => [
            "CRM Visit Plan",
            "Referral / Introduction",
            "Agent / Partner",
            "Social Media",
            "Market Rumor / Market Intelligence",
            "Cold Walk-in / On the street",
            "Inbound",
            "Event",
            "Other",
        ],
        []
    );
    const leadOwnershipOptions = useMemo(() => ["Shared", "Exclusive"], []);
    const rumorTrustScoreOptions = useMemo(() => ["Low", "Medium", "High"], []);
    const socialPlatformOptions = useMemo(() => ["LinkedIn", "Instagram", "X", "Other"], []);
    const contactRoleOptions = useMemo(
        () => [
            "Owner",
            "CEO",
            "CFO",
            "COO",
            "Head of Logistics",
            "Logistics Manager",
            "Procurement",
            "Operations",
            "Sales",
            "Other",
        ],
        []
    );
    const tradeTypeOptions = useMemo(() => ["Export", "Import", "Cross-trade"], []);
    const modeOptions = useMemo(() => ["Ocean", "Air", "Road", "Project"], []);
    const projectSubtypeOptions = useMemo(() => ["Multimodal", "OOG & Heavy", "Breakbulk"], []);
    const leadStatusOptions = useMemo(() => ["New", "Sent", "In progress", "Converted", "Lost"], []);
    const followUpPlanOptions = useMemo(() => ["30", "60", "custom"], []);
    const actionTypeOptions = useMemo(() => ["Call", "Email", "Visit", "Meeting", "Send Offer", "Follow Up", "Other"], []);
    const salesRepById = useMemo(() => {
        const m = new Map();
        salesRepOptions.forEach((o) => m.set(o.id, o));
        return m;
    }, [salesRepOptions]);

    const customerOptions = useMemo(() => (partyType === "Customer" ? customerList : globalAgentList), [
        partyType,
        customerList,
        globalAgentList,
    ]);

    useEffect(() => {
        if (form.selectedCustomer && form.selectedCustomer.type !== partyType) {
            dispatch({ type: "SET", key: "selectedCustomer", value: null });
        }
        setInputValue("");
        setOpen(false);
    }, [partyType]);

    // sales reps
    useEffect(() => {
        (async () => {
            try {
                const response = await CrudService.getUsers();
                const users = response.data || [];
                const formattedUsers = users.map((u) => ({
                    id: u.id,
                    label: u.attributes?.name || "",
                    email: u.attributes?.email || "",
                }));
                setSalesRepOptions(formattedUsers);
            } catch (error) {
                console.error("Satış temsilcileri alınamadı:", error);
            }
        })();
    }, []);

    // Customer & GA
    useEffect(() => {
        (async () => {
            try {
                const [customerResponse, globalAgentResponse] = await Promise.all([
                    CrudService.getCustomers(),
                    CrudService.getGlobalAgents(),
                ]);

                const customers = (customerResponse.data || []).map((c) => ({
                    name: c.attributes?.name || "Unnamed Customer",
                    id: c.id,
                    email: c.attributes?.email || "customer@example.com",
                    type: "Customer",
                }));
                const globalAgents = (globalAgentResponse.data || []).map((a) => ({
                    name: a.attributes?.name || "Unnamed Global Agent",
                    id: a.id,
                    email: a.attributes?.email || "globalAgent@example.com",
                    type: "GlobalAgent",
                }));
                setCustomerList(customers);
                setGlobalAgentList(globalAgents);
            } catch (error) {
                console.error("Party verileri alınırken hata:", error);
            }
        })();
    }, []);

    const [customerOptions2, setCustomerOptions] = useState([]);
    const [partyOptions, setPartyOptions] = useState([]);

    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const [customersRes, agentsRes] = await Promise.all([
                    CrudService.getCustomers(),
                    CrudService.getGlobalAgents(),
                ]);

                const customers = (customersRes.data || []).map((c) => ({
                    id: c.id,
                    name: c.attributes?.name || "Unnamed Customer",
                    type: "customer",
                }));

                const agents = (agentsRes.data || []).map((a) => ({
                    id: a.id,
                    name: a.attributes?.name || a.name || "Unnamed Global Agent",
                    type: "agent",
                }));

                const merged = [...customers, ...agents].sort((x, y) =>
                    (x.name || "").localeCompare(y.name || "")
                );

                setCustomerOptions(customers);  // ✅ EKLE
                setPartyOptions(merged);
            } catch (err) {
                console.error("Options alınırken hata oluştu:", err);
            }
        };

        fetchOptions();
    }, []);

// companies (string[]) + partyOptions (object[]) => string[]
    const shipperConsigneeOptions = useMemo(() => {
        const companyItems = (companies || [])
            .map((name) => String(name || "").trim())
            .filter(Boolean)
            .map((name) => ({
                id: `company-${name.toLowerCase()}`,
                name,
                type: "company",
            }));

        const customerItems = (customerList || [])
            .filter((c) => c?.name)
            .map((c) => ({
                id: `customer-${c.id}`,
                name: String(c.name).trim(),
                type: "customer",
            }));

        const agentItems = (globalAgentList || [])
            .filter((a) => a?.name)
            .map((a) => ({
                id: `agent-${a.id}`,
                name: String(a.name).trim(),
                type: "agent",
            }));

        // unique by type+name
        const map = new Map();
        [...companyItems, ...customerItems, ...agentItems].forEach((item) => {
            const key = `${item.type}::${item.name.toLowerCase()}`;
            if (!map.has(key)) map.set(key, item);
        });

        return Array.from(map.values()).sort((a, b) => a.name.localeCompare(b.name));
    }, [companies, customerList, globalAgentList]);
    const findOptionByName = (name) =>
        shipperConsigneeOptions.find(
            (o) => (o.name || "").toLowerCase() === String(name || "").toLowerCase()
        ) || null;

    const makeFreeOption = (name) => ({
        id: `free-${String(name).toLowerCase()}`,
        name: String(name),
        type: "custom",
    });

    const getShipperValue = () => {
        if (!form.shipper) return null;
        return findOptionByName(form.shipper) || makeFreeOption(form.shipper);
    };

    const getConsigneeValue = () => {
        if (!form.consignee) return null;
        return findOptionByName(form.consignee) || makeFreeOption(form.consignee);
    };
    useEffect(() => {
        if (!leadCompany) return;
        if (customerList.length === 0 && globalAgentList.length === 0) return;
        const lc = leadCompany.trim().toLowerCase();
        const all = [...customerList, ...globalAgentList];
        const found = all.find((x) => x.name?.trim().toLowerCase() === lc);
        if (found) {
            setPartyType(found.type);
            dispatch({ type: "SET", key: "selectedCustomer", value: found });
        }
    }, [leadCompany, customerList, globalAgentList]);

    useEffect(() => {
        const country = (form.customerCountry || "").trim();
        if (!country) {
            setCityOptions([]);
            dispatch({ type: "SET", key: "city", value: "" });
            return;
        }
        let cancelled = false;
        (async () => {
            setCityLoading(true);
            try {
                const res = await CrudService.getCitiesByCountry(country);
                const raw = res?.data?.data ?? res?.data ?? [];
                const normalized = raw
                    .map((x) => (typeof x === "string" ? x : x?.name || x?.label))
                    .filter(Boolean);
                if (cancelled) return;
                setCityOptions(normalized);
                const norm = (s) => (s || "").trim().toLowerCase();
                if (!fromVisitPlan && form.city && !normalized.some((x) => norm(x) === norm(form.city))) {
                    dispatch({ type: "SET", key: "city", value: "" });}
            } catch (e) {
                console.error("City list fetch error:", e);
                if (!cancelled) setCityOptions([]);
            } finally {
                if (!cancelled) setCityLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [form.customerCountry, form.city, fromVisitPlan]);

    useEffect(() => {
        if (!fromVisitPlan) return;
        if (!form.city) return;
        if (!Array.isArray(cityOptions) || cityOptions.length === 0) return;
        const norm = (s) => (s || "").trim().toLowerCase();
        const matched = cityOptions.find((x) => norm(x) === norm(form.city));
        if (matched) {
            dispatch({ type: "SET", key: "city", value: capFirst(matched) });
        } else {
            dispatch({ type: "SET", key: "city", value: capFirst(form.city) });
        }
    }, [fromVisitPlan, cityOptions, form.city]);


    const didInitSourceDetail = useRef(false);
    useEffect(() => {
        if (!form.sourceType) return;
        if (isEditing && !didInitSourceDetail.current) {
            didInitSourceDetail.current = true;
            return;
        }
        if (fromVisitPlan && form.sourceType === "CRM Visit Plan") return;
        dispatch({
            type: "SET",
            key: "sourceDetail",
            value: { ...initialForm.sourceDetail },
        });
    }, [form.sourceType, isEditing, fromVisitPlan]);


    const fetchLeadDetails = useCallback(
        async (id) => {
            if (customerList.length === 0 && globalAgentList.length === 0) return;
            if (salesRepOptions.length === 0) return;
            setLoading(true);
            try {
                const response = await CrudService.getLeadById(id);
                const leadData = response.data.attributes;
                const nameLc = (leadData.customer || "").trim().toLowerCase();
                const cMatch = customerList.find((o) => o.name?.trim().toLowerCase() === nameLc);
                const gaMatch = globalAgentList.find((o) => o.name?.trim().toLowerCase() === nameLc);
                const inferredType = cMatch ? "Customer" : gaMatch ? "GlobalAgent" : partyType;
                setPartyType(inferredType);
                const candidates = inferredType === "Customer" ? customerList : globalAgentList;
                const matchedCustomer = candidates.find(
                    (opt) => opt.name?.trim().toLowerCase() === leadData.customer?.trim().toLowerCase()
                );
                const salesRepSelected = Array.isArray(leadData.salesRep)
                    ? leadData.salesRep.map((rid) => salesRepById.get(rid)).filter(Boolean)
                    : [];
                const attendeesSelected = Array.isArray(leadData.attendees)
                    ? leadData.attendees.map((rid) => salesRepById.get(rid)).filter(Boolean)
                    : [];
                dispatch({
                    type: "PATCH",
                    payload: {
                        selectedCustomer: matchedCustomer || null,
                        taxId: leadData.taxId || "",
                        customerCountry: leadData.customerCountry || "",
                        city: leadData.city || "",
                        representatives: leadData.representatives || "",
                        representativesTitle: leadData.representativesTitle || "",
                        representativesContact: leadData.representativesContact || "",
                        webSite: leadData.webSite || "",
                        shipper: toEngUpper(leadData.shipper || ""),
                        consignee: toEngUpper(leadData.consignee || ""),
                        industry: Array.isArray(leadData?.customerIndustry)
                            ? leadData.customerIndustry.join(", ")
                            : (leadData.industry || ""),
                        companySize: leadData.companySize || "",
                        logisticsDecision: leadData.logisticsDecision || "",
                        sourceType: leadData.sourceType || "",
                        sourceDetail: leadData.sourceDetail ? leadData.sourceDetail : { ...initialForm.sourceDetail },
                        contacts: Array.isArray(leadData.contacts) && leadData.contacts.length
                            ? leadData.contacts
                            : [{ name: "", role: "", email: "", phone: "" }],
                        tradeType: leadData.tradeType || "",
                        incoterm: leadData.incoterm || "",
                        laneOriginCountry: leadData.laneOriginCountry || "",
                        laneOriginCityOrPort: leadData.laneOriginCityOrPort || "",
                        laneDestinationCountry: leadData.laneDestinationCountry || "",
                        laneDestinationCityOrPort: leadData.laneDestinationCityOrPort || "",
                        commodityOrVertical: leadData.commodityOrVertical || "",
                        leadStatus: leadData.leadStatus || "New",
                        followUpPlan: leadData.followUpPlan || "30",
                        followUpCustomDays: leadData.followUpCustomDays || "",
                        nextActionDate: safeParseDate(leadData.nextActionDate),
                        nextActionType: leadData.nextActionType || "",
                        preMeetingTitle: leadData.preMeetingTitle || "",
                        preMeetingNotes: leadData.preMeetingNotes || "",
                        meetingTitle: leadData.meetingTitle || "",
                        meetingDate: safeParseDate(leadData.meetingDate),
                        meetingTime: leadData.meetingTime || "",
                        meetingDuration: leadData.meetingDuration || "",
                        meetingType: leadData.meetingType || "",
                        meetingStatus: leadData.meetingStatus || "Planned",
                        participants: Array.isArray(leadData.participants) ? leadData.participants : [""],
                        meetingPlatform: leadData.meetingPlatform || "",
                        meetingNotes: leadData.meetingNotes || "",
                        recapMeetingNotes: leadData.recapMeetingNotes || "",
                        salesRep: salesRepSelected,
                        attendees: attendeesSelected,
                        globalAgentName: leadData.globalAgentName || "",
                        competitorCompanyName: leadData.competitorCompanyName || "",
                        productServiceModes:
                            Array.isArray(leadData.productServiceModes) && leadData.productServiceModes.length
                                ? leadData.productServiceModes
                                : [{
                                    serviceMode: leadData.serviceMode || "",
                                    projectSubtype: leadData.projectSubtype || "",
                                    volumeEstimate: leadData.volumeEstimate || "",
                                }],
                    },
                });
                const lo = leadData.laneOrigin || {};
                const ld = leadData.laneDestination || {};
                setLeadData((p) => ({
                    ...p,
                    origin: {
                        country: lo.country || "",
                        placeLabel: lo.placeLabel || "",
                        placeType: lo.placeType || "",
                        placeId: lo.placeId || "",
                        additionalInfo: lo.additionalInfo || "",
                    },
                    destination: {
                        country: ld.country || "",
                        placeLabel: ld.placeLabel || "",
                        placeType: ld.placeType || "",
                        placeId: ld.placeId || "",
                        additionalInfo: ld.additionalInfo || "",
                    },
                }));

                setSelectedOriginCountry(lo.country ? { label: lo.country } : null);
                setSelectedDestinationCountry(ld.country ? { label: ld.country } : null);
                setSelectedOriginPlace(
                    lo.placeLabel ? { type: lo.placeType || "CITY", id: lo.placeId || "", label: lo.placeLabel, raw: lo } : null
                );
                setSelectedDestinationPlace(
                    ld.placeLabel ? { type: ld.placeType || "CITY", id: ld.placeId || "", label: ld.placeLabel, raw: ld } : null
                );
                setOriginInputValue(lo.placeLabel || "");
                setDestinationInputValue(ld.placeLabel || "");
            } catch (error) {
                console.error("Error fetching lead details:", error);
            } finally {
                setLoading(false);
            }
        },
        [customerList, globalAgentList, partyType, salesRepOptions.length, salesRepById]
    );


    useEffect(() => {
        if (!leadId) return;
        if (customerList.length === 0 && globalAgentList.length === 0) return;
        if (salesRepOptions.length === 0) return;
        fetchLeadDetails(leadId);
    }, [leadId, customerList, globalAgentList, salesRepOptions, fetchLeadDetails]);

    const handleCustomerChange = useCallback(
        async (_, newValue) => {
            dispatch({ type: "SET", key: "selectedCustomer", value: newValue });
            if (!newValue?.id) {
                dispatch({
                    type: "PATCH",
                    payload: {
                        taxId: "",
                        customerCountry: "",
                        city: "",
                        representatives: "",
                        representativesTitle: "",
                        representativesContact: "",
                        webSite: "",
                        industry: "",
                        shipper: "",
                        consignee: "",
                        participants: [""],
                        salesRep: [],
                    },
                });
                return;
            }

            try {
                const fetchFn = newValue.type === "GlobalAgent" ? CrudService.getGlobalAgentById : CrudService.getCustomerById;
                const response = await fetchFn(newValue.id);
                const attributes = response.data.attributes || {};

                const fetchedSalesReps = attributes.salesRep || [];
                const idArray = fetchedSalesReps.map((rep) => rep._id).filter(Boolean);
                const matchedSalesReps = idArray.map((id) => salesRepById.get(id)).filter(Boolean);

                dispatch({
                    type: "PATCH",
                    payload: {
                        salesRep: matchedSalesReps,
                        taxId: attributes?.taxID || "",
                        city: attributes?.city || "",
                        customerCountry: attributes?.customerCountry || "",
                        representatives: (attributes?.representatives || []).map((r) => r.name).join(", ") || "",
                        representativesTitle: (attributes?.representatives || []).map((r) => r.title).join(", ") || "",
                        representativesContact: (attributes?.representatives || []).map((r) => r.contactInfo).join(", ") || "",
                        webSite: attributes?.website || "",
                        industry: attributes?.customerIndustry || "",
                        shipper: attributes?.shipper || "",
                        consignee: attributes?.consignee || "",
                        participants: (attributes?.representatives || []).map((r) => r.name) || [""],
                    },
                });
            } catch (error) {
                console.error(`${newValue.type} detayları çekilirken hata oluştu:`, error);
            }
        },
        [salesRepById]
    );

    const toEngUpper = (value) => {
        if (value == null) return "";
        let s = String(value).trim();
        s = s
            .replace(/İ/g, "I")
            .replace(/ı/g, "i")
            .replace(/Ş/g, "S")
            .replace(/ş/g, "s")
            .replace(/Ğ/g, "G")
            .replace(/ğ/g, "g")
            .replace(/Ü/g, "U")
            .replace(/ü/g, "u")
            .replace(/Ö/g, "O")
            .replace(/ö/g, "o")
            .replace(/Ç/g, "C")
            .replace(/ç/g, "c");
        s = s.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        s = s.replace(/[^A-Za-z0-9\s.,\-\/&()']/g, "");
        s = s.replace(/\s+/g, " ").trim();
        return s.toUpperCase();
    };

    const validateForm = () => {
        const e = {};

        // Company
        if (!form.selectedCustomer?.name) e.selectedCustomer = "Company is required.";
        if (!form.customerCountry) e.customerCountry = "Company country is required.";
        if (!form.city) e.city = "Company city is required.";

        // Contacts
        if (!Array.isArray(form.contacts) || form.contacts.length === 0) {
            e.contacts = "At least one contact is required.";
        } else {
            const contactErrors = form.contacts.map((c) => {
                const ce = {};
                if (!(c?.name || "").trim()) ce.name = "Contact name is required.";
                if (!(c?.role || "").trim()) ce.role = "Contact role is required.";

                const hasEmail = Boolean((c?.email || "").trim());
                const hasPhone = Boolean((c?.phone || "").trim());
                if (!hasEmail && !hasPhone) ce.contact = "E-mail or phone is required.";

                return ce;
            });

            // sadece dolu error varsa koy
            if (contactErrors.some((x) => Object.keys(x).length > 0)) {
                e.contacts = contactErrors;
            }
        }

        // Trade context
        if (!form.tradeType) e.tradeType = "Trade type is required.";
        if (!form.incoterm) e.incoterm = "Incoterm is required.";
        const psm = Array.isArray(form.productServiceModes) ? form.productServiceModes : [];

        if (psm.length === 0) {
            e.productServiceModes = "At least one mode is required.";
        } else {
            const psmErrors = psm.map((row) => {
                const re = {};
                if (!row.serviceMode) re.serviceMode = "Mode is required.";
                if (row.serviceMode === "Project" && !row.projectSubtype) re.projectSubtype = "Project subtype is required.";
                return re;
            });

            if (psmErrors.some(x => Object.keys(x).length > 0)) {
                e.productServiceModes = psmErrors;
            }
        }
        if (form.serviceMode === "Project" && !form.projectSubtype) e.projectSubtype = "Project subtype is required.";
        if (!form.leadStatus) e.leadStatus = "Lead status is required.";

        // Follow-up
        if (!form.nextActionDate) e.nextActionDate = "Next action date is required.";
        if (!form.nextActionType) e.nextActionType = "Next action type is required.";

        if (form.followUpPlan === "custom") {
            const n = Number(form.followUpCustomDays);
            if (!n || n <= 0) e.followUpCustomDays = "Custom follow-up days must be a positive number.";
        }

        return e;
    };

    const saveLead = useCallback(async () => {
        const e = validateForm();
        setErrors(e);

        if (Object.keys(e).length > 0) {
            openSnack("Please fill required fields.", "error");
            window.scrollTo({ top: 0, behavior: "smooth" });
            return { ok: false };
        }

        const meetingData = {
            customer: form.selectedCustomer ? String(form.selectedCustomer.name) : "Unknown Customer",
            taxId: form.taxId,
            customerCountry: form.customerCountry,
            city: form.city,
            salesRep: form.salesRep.map((rep) => rep.id),
            representatives: form.representatives,
            representativesTitle: form.representativesTitle,
            representativesContact: form.representativesContact,
            webSite: form.webSite,
            industry: form.industry,
            shipper: toEngUpper(form.shipper),
            consignee: toEngUpper(form.consignee),
            companySize: form.companySize,
            logisticsDecision: form.logisticsDecision,
            sourceType: form.sourceType,
            sourceDetail: form.sourceDetail,
            contacts: form.contacts,
            tradeType: form.tradeType,
            incoterm: form.incoterm,
            commodityOrVertical: form.commodityOrVertical,
            productServiceModes: (form.productServiceModes || []).map((x) => ({
                serviceMode: x.serviceMode || "",
                projectSubtype: (x.serviceMode === "Project" ? (x.projectSubtype || "") : ""),
                volumeEstimate: x.volumeEstimate || "",
            })),
            leadStatus: form.leadStatus,
            followUpPlan: form.followUpPlan,
            followUpCustomDays: form.followUpPlan === "custom" ? form.followUpCustomDays : "",
            nextActionDate: form.nextActionDate,
            nextActionType: form.nextActionType,
            preMeetingTitle: form.preMeetingTitle,
            preMeetingNotes: form.preMeetingNotes,
            meetingTitle: form.meetingTitle,
            meetingDate: form.meetingDate,
            meetingTime: form.meetingTime,
            meetingDuration: form.meetingDuration,
            meetingType: form.meetingType,
            meetingStatus: form.meetingStatus,
            participants: form.participants,
            meetingPlatform: form.meetingPlatform,
            meetingNotes: form.meetingNotes,
            recapMeetingNotes: form.recapMeetingNotes,
            laneOrigin: leadData.origin,
            laneDestination: leadData.destination,
            attendees: form.attendees.map((att) => att.id),
            globalAgentName: form.globalAgentName,
            competitorCompanyName: form.competitorCompanyName,
        };

        try {
            setLoading(true);

            if (isEditing) {
                await CrudService.updateLead(meetingData, leadId);
                openSnack("Update sales lead was successfully completed.", "success");
                return { ok: true, leadId };
            } else {
                // önemli: createLead response'undan id alabiliyorsan bunu döndür
                const res = await CrudService.createLead({ data: meetingData });
                openSnack("Create sales lead was successfully completed.", "success");

                const createdId = res?.data?.id || res?.data?.data?.id || null;
                return { ok: true, leadId: createdId };
            }
        } catch (err) {
            console.error("Request failed: ", err);
            openSnack("Request failed. Please try again.", "error");
            return { ok: false };
        } finally {
            setLoading(false);
        }
    }, [form, leadData, isEditing, leadId, openSnack]);



    const submitHandler = useCallback(async (event) => {
        event.preventDefault();
        const result = await saveLead();
        if (!result.ok) return;

        window.scrollTo({ top: 0, behavior: "smooth" });
        setTimeout(() => navigate("/sales-lead/sales-lead-tables/details"), 1000);
    }, [saveLead, navigate]);

    const handleCreateOpp = useCallback(async () => {
        const result = await saveLead();
        if (!result.ok) return;

        const firstMode = form.productServiceModes?.[0]?.serviceMode || "";
        const transportType = mapServiceModeToTransport(firstMode);

        // origin/destination normalize (country/port çıkar)
        const originCountry =
            leadData?.origin?.country?.label ||
            leadData?.origin?.country ||
            leadData?.origin?.originCountry ||
            "";

        const originPort =
            leadData?.origin?.port?.label ||
            leadData?.origin?.port ||
            leadData?.origin?.originPort ||
            leadData?.origin?.city ||  // bazı yapılarda city diye geliyor olabilir
            "";

        const destinationCountry =
            leadData?.destination?.country?.label ||
            leadData?.destination?.country ||
            leadData?.destination?.destinationCountry ||
            "";

        const destinationPort =
            leadData?.destination?.port?.label ||
            leadData?.destination?.port ||
            leadData?.destination?.destinationPort ||
            leadData?.destination?.city ||
            "";

        const salesRepIds = Array.isArray(form.salesRep)
            ? form.salesRep.map(x => x?.id).filter(Boolean)
            : form.salesRep?.id
                ? [form.salesRep.id]
                : [];

        navigate("/create-opportunity", {
            state: {
                // CreateOpportunity için
                selectedTransportType: transportType,

                // Lead bilgileri (senin mevcut)
                leadId: result.leadId || leadId || null,
                customerName: form.selectedCustomer?.name || "",
                customerId: form.selectedCustomer?.id || "",
                partyType: form.selectedCustomer?.type || partyType,
                incoterm: form.incoterm,
                tradeType: form.tradeType,
                commodityOrVertical: form.commodityOrVertical,
                volumeEstimate: form.volumeEstimate,
                laneOrigin: leadData.origin,
                laneDestination: leadData.destination,
                contacts: form.contacts,
                salesRep: form.salesRep,
                attendees: form.attendees,

                // ✅ RoadForm için eklediklerimiz
                fromLead: true,
                customer: form.selectedCustomer
                    ? { id: form.selectedCustomer.id, name: form.selectedCustomer.name, type: form.selectedCustomer.type }
                    : null,

                salesRepIds, // RoadForm bunu salesRepOptions geldikten sonra map’leyecek

                origin: { country: originCountry, port: originPort },
                destination: { country: destinationCountry, port: destinationPort },
            },
        });
    }, [
        saveLead,
        form.serviceMode,
        form.selectedCustomer,
        form.incoterm,
        form.tradeType,
        form.commodityOrVertical,
        form.volumeEstimate,
        form.contacts,
        form.salesRep,
        form.attendees,
        leadData,
        navigate,
        leadId,
        partyType
    ]);



    const goToPartyDetail = useCallback(() => {
        if (!form.selectedCustomer?.id) return;
        if (form.selectedCustomer.type === "Customer") {
            navigate(`/customer/create-customer/details?id=${form.selectedCustomer.id}`);
        } else {
            navigate(`/global-agent/create-global-agent/details?id=${form.selectedCustomer.id}`);
        }
    }, [form.selectedCustomer, navigate]);

    const renderSourceDetailFields = () => {
        const st = form.sourceType;
        if (!st) return null;

        if (st === "CRM Visit Plan") {
            return (
                <Grid container spacing={2} mt={0}>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            label="Visit Plan ID"
                            value={form.sourceDetail.visitPlanId || ""}
                            onChange={(e) => dispatch({ type: "SET_SOURCE_DETAIL", payload: { visitPlanId: e.target.value } })}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            label="Visit Note Link"
                            value={form.sourceDetail.visitNoteLink || ""}
                            onChange={(e) => dispatch({ type: "SET_SOURCE_DETAIL", payload: { visitNoteLink: e.target.value } })}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            type="date"
                            label="Visit Date"
                            value={formatDateInput(form.sourceDetail.visitDate)}
                            onChange={(e) =>
                                dispatch({
                                    type: "SET_SOURCE_DETAIL",
                                    payload: { visitDate: e.target.value ? new Date(e.target.value) : null },
                                })
                            }
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                </Grid>
            );
        }

        if (st === "Referral / Introduction") {
            return (
                <Grid container spacing={2} mt={0}>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            label="Referrer Name"
                            value={form.sourceDetail.referrerName || ""}
                            onChange={(e) => dispatch({ type: "SET_SOURCE_DETAIL", payload: { referrerName: e.target.value } })}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            label="Referrer Company"
                            value={form.sourceDetail.referrerCompany || ""}
                            onChange={(e) => dispatch({ type: "SET_SOURCE_DETAIL", payload: { referrerCompany: e.target.value } })}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            label="Referrer Contact"
                            value={form.sourceDetail.referrerContact || ""}
                            onChange={(e) => dispatch({ type: "SET_SOURCE_DETAIL", payload: { referrerContact: e.target.value } })}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            placeholder="email / phone / linkedin"
                        />
                    </Grid>
                </Grid>
            );
        }

        if (st === "Agent / Partner") {
            return (
                <Grid container spacing={2} mt={0}>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            label="Agent ID"
                            value={form.sourceDetail.agentId || ""}
                            onChange={(e) => dispatch({ type: "SET_SOURCE_DETAIL", payload: { agentId: e.target.value } })}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            label="Agent Contact"
                            value={form.sourceDetail.agentContact || ""}
                            onChange={(e) => dispatch({ type: "SET_SOURCE_DETAIL", payload: { agentContact: e.target.value } })}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            placeholder="email / phone"
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Autocomplete
                            options={leadOwnershipOptions}
                            value={form.sourceDetail.leadOwnership || ""}
                            onChange={(_, v) => dispatch({ type: "SET_SOURCE_DETAIL", payload: { leadOwnership: v || "" } })}
                            renderInput={(params) => (
                                <TextField {...params} label="Lead Ownership" fullWidth InputLabelProps={{ shrink: true }} />
                            )}
                        />
                    </Grid>
                </Grid>
            );
        }

        if (st === "Social Media") {
            return (
                <Grid container spacing={2} mt={0}>
                    <Grid item xs={12} sm={3}>
                        <Autocomplete
                            options={socialPlatformOptions}
                            value={form.sourceDetail.socialPlatform || ""}
                            onChange={(_, v) => dispatch({ type: "SET_SOURCE_DETAIL", payload: { socialPlatform: v || "" } })}
                            renderInput={(params) => <TextField {...params} label="Platform" fullWidth InputLabelProps={{ shrink: true }} />}
                        />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <TextField
                            label="Profile Link"
                            value={form.sourceDetail.socialProfileLink || ""}
                            onChange={(e) => dispatch({ type: "SET_SOURCE_DETAIL", payload: { socialProfileLink: e.target.value } })}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            label="Message Screenshot Link"
                            value={form.sourceDetail.messageScreenshotLink || ""}
                            onChange={(e) => dispatch({ type: "SET_SOURCE_DETAIL", payload: { messageScreenshotLink: e.target.value } })}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                </Grid>
            );
        }

        if (st === "Market Rumor / Market Intelligence") {
            return (
                <Grid container spacing={2} mt={0}>
                    <Grid item xs={12} sm={3}>
                        <Autocomplete
                            options={rumorTrustScoreOptions}
                            value={form.sourceDetail.rumorTrustScore || ""}
                            onChange={(_, v) => dispatch({ type: "SET_SOURCE_DETAIL", payload: { rumorTrustScore: v || "" } })}
                            renderInput={(params) => <TextField {...params} label="Trust Score" fullWidth InputLabelProps={{ shrink: true }} />}
                        />
                    </Grid>
                    <Grid item xs={12} sm={9}>
                        <TextField
                            label="Rumor Note"
                            value={form.sourceDetail.rumorNote || ""}
                            onChange={(e) => dispatch({ type: "SET_SOURCE_DETAIL", payload: { rumorNote: e.target.value } })}
                            fullWidth
                            multiline
                            minRows={2}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                </Grid>
            );
        }

        if (st === "Cold Walk-in / On the street") {
            return (
                <Grid container spacing={2} mt={0}>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            label="Location"
                            value={form.sourceDetail.walkInLocation || ""}
                            onChange={(e) => dispatch({ type: "SET_SOURCE_DETAIL", payload: { walkInLocation: e.target.value } })}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <TextField
                            label="Short Note"
                            value={form.sourceDetail.walkInNote || ""}
                            onChange={(e) => dispatch({ type: "SET_SOURCE_DETAIL", payload: { walkInNote: e.target.value } })}
                            fullWidth
                            multiline
                            minRows={2}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                </Grid>
            );
        }

        return (
            <Grid container spacing={2} mt={0}>
                <Grid item xs={12}>
                    <TextField
                        label="Source Note / Detail"
                        value={form.sourceDetail.walkInNote || ""}
                        onChange={(e) => dispatch({ type: "SET_SOURCE_DETAIL", payload: { walkInNote: e.target.value } })}
                        fullWidth
                        multiline
                        minRows={2}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
            </Grid>
        );
    };

    const mapServiceModeToTransport = (serviceMode) => {
        switch (serviceMode) {
            case "Road":
                return "Road";
            case "Ocean":
                return "Ocean";
            case "Air":
                return "Air";
            case "Project":
                return "ProjectCargo";
            default:
                return ""; // boşsa kullanıcı CreateOpportunity'de seçer
        }
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />

            <MDBox pt={3}>
                {/* Başarı mesajı: ref, kayıttan sonra mesaja kaydırmak için kullanılır */}
                <div ref={successMessageRef}>
                    {successMessage && <CrmNotice sx={{ mb: 2 }}>{successMessage}</CrmNotice>}
                </div>
                <CrmPageHeader
                    title={isEditing ? "Edit Sales Lead Details" : "Add Sales Lead Details"}
                    subtitle="This information will give you more information about the Sales Lead Card."
                />
                {readOnlyMode && (
                    <ReadOnlyBanner
                        message="This sales lead is in read-only view. Click Edit to make changes."
                        onEdit={() => setReadOnlyMode(false)}
                    />
                )}
            </MDBox>

            <ReadOnlyFieldset readOnly={readOnlyMode}>
            <MDBox
                sx={{
                    ...crmCardSx,
                    overflow: "visible",
                    p: 3,

                    "& .MuiFormControl-root": { width: "100%" },

                    "& .MuiInputBase-root": { height: 40, boxSizing: "border-box" },

                    "& .MuiAutocomplete-inputRoot": {
                        paddingTop: "0px !important",
                        paddingBottom: "0px !important",
                    },

                    "& .MuiInputBase-input": {
                        height: "40px",
                        padding: "0 12px",
                        boxSizing: "border-box",
                        display: "flex",
                        alignItems: "center",
                    },

                    "& .MuiInputBase-multiline": {
                        height: "auto",
                        padding: "8px 12px",
                        alignItems: "flex-start",
                    },

                    // ✅ helper alanını sabitle (error gelince kaymasın)
                    "& .MuiFormHelperText-root": {
                        marginLeft: 0,
                        minHeight: "18px",     // 1 satır helper yüksekliği
                        lineHeight: "18px",
                    },
                }}
            >


            <MDBox mt={3}>
                    <MDTypography variant="h6">
                        {partyType === "Customer" ? "CUSTOMER INFORMATION" : "GLOBAL AGENT INFORMATION"}
                    </MDTypography>

                    {form.selectedCustomer && (
                        <MDTypography
                            variant="caption"
                            onClick={goToPartyDetail}
                            sx={{
                                cursor: "pointer",
                                color: "#1976d2",
                                fontWeight: 600,
                                textDecoration: "underline",
                                mt: 0.5,
                                display: "inline-block",
                            }}
                        >
                            {form.selectedCustomer.name}
                        </MDTypography>
                    )}
                </MDBox>

                <MDBox mt={3}>
                    {/* ROW 1 */}
                    <Grid container spacing={2} alignItems="flex-end">
                        <Grid item xs={12} sm={2}>
                            <ToggleButtonGroup
                                color="primary"
                                value={partyType}
                                exclusive
                                onChange={(_, val) => val && setPartyType(val)}
                                size="small"
                                fullWidth
                                sx={{
                                    ".MuiToggleButtonGroup-grouped": {
                                        flex: 1,
                                        borderColor: "#ddd !important",
                                        "&.Mui-selected": { bgcolor: "#e6f0ff" },
                                    },
                                    ".MuiToggleButton-root": {
                                        textTransform: "none",
                                        fontWeight: 600,
                                        height: 55,
                                    },
                                }}
                            >
                                <ToggleButton value="Customer">Customer</ToggleButton>
                                <ToggleButton value="GlobalAgent">Global Agent</ToggleButton>
                            </ToggleButtonGroup>
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                value={form.selectedCustomer || null}
                                onChange={handleCustomerChange}
                                inputValue={inputValue}
                                onInputChange={(_, v) => {
                                    setInputValue(v);
                                    if (fromVisitPlan) {
                                        setOpen(false);
                                        return;
                                    }
                                    setOpen(v.length > 0);
                                }}
                                options={customerOptions}
                                getOptionLabel={(o) => o?.name || ""}
                                open={fromVisitPlan ? false : (isEditing ? false : open)}
                                onClose={() => setOpen(false)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={partyType === "Customer" ? "Search Customer" : "Search Global Agent"}
                                        variant="outlined"
                                        size="small"
                                        sx={{ "& .MuiInputBase-root": { height: 40, paddingRight: "32px !important" } }}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} sm={1}>
                            <TextField
                                label="Tax ID"
                                value={form.taxId}
                                onChange={(e) => dispatch({ type: "SET", key: "taxId", value: e.target.value })}
                                fullWidth
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                sx={{ "& .MuiInputBase-root": { height: 40 } }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                fullWidth
                                options={countryOptions}
                                getOptionLabel={(o) => o.label}
                                value={form.customerCountry ? { label: form.customerCountry } : null}
                                onChange={(_, n) => dispatch({ type: "SET", key: "customerCountry", value: n ? n.label : "" })}
                                size="small"
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={t("Country")}
                                        size="small"
                                        variant="outlined"
                                        error={Boolean(errors.customerCountry)}
                                        helperText={errors.customerCountry || ""}
                                        sx={{
                                            "& .MuiOutlinedInput-root": { height: 45 },
                                        }}
                                    />
                                )}
                                sx={{
                                    "& .MuiOutlinedInput-root": { height: 45 },
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                fullWidth
                                options={cityOptions}
                                loading={cityLoading}
                                value={form.city || null}
                                isOptionEqualToValue={(opt, val) => {
                                    const norm = (s) => (s || "").trim().toLowerCase();
                                    return norm(opt) === norm(val);
                                }}
                                onChange={(_, v) => dispatch({ type: "SET", key: "city", value: capFirst(v || "") })}
                                // ✅ listeden seçilecek: freeSolo + onInputChange yok
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="City"
                                        variant="outlined"
                                        size="small"
                                        InputLabelProps={{ shrink: true }}
                                        error={Boolean(errors.city)}
                                        helperText={errors.city || ""}
                                        sx={{ "& .MuiInputBase-root": { height: 45 } }}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                    {/* ROW 2 - existing company fields */}
                    <Grid container spacing={3} alignItems="flex-end" mt={1}>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                type="text"
                                label="Web Site"
                                value={form.webSite}
                                onChange={(e) => dispatch({ type: "SET", key: "webSite", value: e.target.value })}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                sx={{ "& .MuiInputBase-root": { height: 40 } }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <TextField
                                type="text"
                                label="Industry"
                                value={form.industry}
                                onChange={(e) => dispatch({ type: "SET", key: "industry", value: e.target.value })}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                sx={{ "& .MuiInputBase-root": { height: 40, padding: "0 8px" } }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                options={companySizeOptions}
                                value={form.companySize || null}
                                onChange={(_, v) => dispatch({ type: "SET", key: "companySize", value: v || "" })}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Company Size"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        sx={{ "& .MuiInputBase-root": { height: 40, padding: "0 8px" } }}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                options={logisticsOptions}
                                value={form.logisticsDecision || null}
                                onChange={(_, v) => dispatch({ type: "SET", key: "logisticsDecision", value: v || "" })}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Logistics Decision Authority"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        sx={{ "& .MuiInputBase-root": { height: 40, padding: "0 8px" } }}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Autocomplete
                                options={shipperConsigneeOptions}
                                value={getShipperValue()}
                                freeSolo
                                onChange={(_, opt) => {
                                    const name = typeof opt === "string" ? opt : (opt?.name || "");
                                    dispatch({ type: "SET", key: "shipper", value: toEngUpper(name) });
                                }}
                                onInputChange={(_, v, reason) => {
                                    if (reason === "input") {
                                        dispatch({ type: "SET", key: "shipper", value: toEngUpper(v) });
                                    }
                                }}
                                getOptionLabel={(option) => {
                                    if (typeof option === "string") return option;
                                    return option?.name || "";
                                }}
                                isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                                renderOption={({ key: optionKey, ...props }, option) => (
                                    <li {...props} key={option.id}>
                                        {option.name}
                                        <span style={{ marginLeft: 8, opacity: 0.7, fontSize: 12 }}>
        {option.type === "customer"
            ? "(Customer)"
            : option.type === "agent"
                ? "(Global Agent)"
                : option.type === "company"
                    ? "(Company)"
                    : "(Custom)"}
      </span>
                                    </li>
                                )}
                                renderInput={(params) => (
                                    <TextField {...params} label="Shipper" InputLabelProps={{ shrink: true }} />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Autocomplete
                                options={shipperConsigneeOptions}
                                value={getConsigneeValue()}
                                freeSolo
                                onChange={(_, opt) => {
                                    const name = typeof opt === "string" ? opt : (opt?.name || "");
                                    dispatch({ type: "SET", key: "consignee", value: toEngUpper(name) });
                                }}
                                onInputChange={(_, v, reason) => {
                                    if (reason === "input") {
                                        dispatch({ type: "SET", key: "consignee", value: toEngUpper(v) });
                                    }
                                }}
                                getOptionLabel={(option) => {
                                    if (typeof option === "string") return option;
                                    return option?.name || "";
                                }}
                                isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                                renderOption={({ key: optionKey, ...props }, option) => (
                                    <li {...props} key={option.id}>
                                        {option.name}
                                        <span style={{ marginLeft: 8, opacity: 0.7, fontSize: 12 }}>
        {option.type === "customer"
            ? "(Customer)"
            : option.type === "agent"
                ? "(Global Agent)"
                : option.type === "company"
                    ? "(Company)"
                    : "(Custom)"}
      </span>
                                    </li>
                                )}
                                renderInput={(params) => (
                                    <TextField {...params} label="Consignee" InputLabelProps={{ shrink: true }} />
                                )}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} alignItems="flex-end" mt={1}>
                        <Grid item xs={12} sm={6}>
                            <Autocomplete
                                options={globalAgentNameOptions}
                                value={form.globalAgentName || ""}
                                onChange={(_, v) => dispatch({ type: "SET", key: "globalAgentName", value: v || "" })}
                                freeSolo
                                onInputChange={(_, v, reason) => {
                                    if (reason === "input") dispatch({ type: "SET", key: "globalAgentName", value: v || "" });
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Global Agent"
                                        InputLabelProps={{ shrink: true }}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Autocomplete
                                options={competitorCompanyOptions}
                                loading={competitorLoading}
                                value={form.competitorCompanyName || ""}
                                onChange={(_, v) => dispatch({ type: "SET", key: "competitorCompanyName", value: v || "" })}
                                freeSolo
                                onInputChange={(_, v, reason) => {
                                    if (reason === "input") dispatch({ type: "SET", key: "competitorCompanyName", value: v || "" });
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Competitor"
                                        InputLabelProps={{ shrink: true }}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>

                    <MDBox mt={2}>
                        <MDTypography variant="h6">LEAD QUALIFICATION — ACCOUNT & CONTACT</MDTypography>
                    </MDBox>


                    {form.contacts.map((c, idx) => (
                        <MDBox key={idx} mt={1}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} sm={3}>
                                    <TextField
                                        label="Contact Name *"
                                        value={c.name}
                                        onChange={(e) => {
                                            const next = [...form.contacts];
                                            next[idx] = { ...next[idx], name: e.target.value };
                                            dispatch({ type: "SET", key: "contacts", value: next });
                                        }}
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        error={Boolean(errors?.contacts?.[idx]?.name)}
                                        helperText={errors?.contacts?.[idx]?.name || ""}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3}>
                                    <Autocomplete
                                        options={contactRoleOptions}
                                        value={c.role || null}
                                        onChange={(_, v) => {
                                            const next = [...form.contacts];
                                            next[idx] = { ...next[idx], role: v || "" };
                                            dispatch({ type: "SET", key: "contacts", value: next });
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Contact Role *"
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors?.contacts?.[idx]?.role)}
                                                helperText={errors?.contacts?.[idx]?.role || ""}
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3}>
                                    <TextField
                                        label="E-mail"
                                        value={c.email}
                                        onChange={(e) => {
                                            const next = [...form.contacts];
                                            next[idx] = { ...next[idx], email: e.target.value };
                                            dispatch({ type: "SET", key: "contacts", value: next });
                                        }}
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={2}>
                                    <TextField
                                        label="Phone"
                                        value={c.phone}
                                        onChange={(e) => {
                                            const next = [...form.contacts];
                                            next[idx] = { ...next[idx], phone: e.target.value };
                                            dispatch({ type: "SET", key: "contacts", value: next });
                                        }}
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>

                                {/* + / - aynı satırda */}
                                <Grid item xs={12} sm={1} display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
                                    {/* - sadece 1’den fazlaysa */}
                                    {form.contacts.length > 1 && (
                                        <Box
                                            onClick={() => {
                                                const next = form.contacts.filter((_, i) => i !== idx);
                                                dispatch({ type: "SET", key: "contacts", value: next });
                                            }}
                                            sx={{
                                                width: 28,
                                                height: 28,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "50%",
                                                backgroundColor: "#ffebee",
                                                color: "red",
                                                fontSize: 18,
                                                fontWeight: "bold",
                                                cursor: "pointer",
                                                transition: "all 0.2s ease",
                                                "&:hover": {
                                                    backgroundColor: "#ffcdd2",
                                                    transform: "scale(1.1)",
                                                },
                                            }}
                                        >
                                            −
                                        </Box>
                                    )}
                                    {idx === form.contacts.length - 1 && (
                                        <Box
                                            onClick={() => {
                                                dispatch({
                                                    type: "SET",
                                                    key: "contacts",
                                                    value: [...form.contacts, { name: "", role: "", email: "", phone: "" }],
                                                });
                                            }}
                                            sx={{
                                                width: 28,
                                                height: 28,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "50%",
                                                backgroundColor: "#e8f5e9",
                                                color: "green",
                                                fontSize: 18,
                                                fontWeight: "bold",
                                                cursor: "pointer",
                                                transition: "all 0.2s ease",
                                                "&:hover": {
                                                    backgroundColor: "#c8e6c9",
                                                    transform: "scale(1.1)",
                                                },
                                            }}
                                        >
                                            +
                                        </Box>
                                    )}
                                </Grid>

                            </Grid>
                        </MDBox>
                    ))}

                    {/* ✅ B) Trade Context */}
                    <MDBox mt={2}>
                        <MDTypography variant="h6">LEAD QUALIFICATION — TRADE CONTEXT</MDTypography>
                    </MDBox>

                    <Grid container spacing={2} alignItems="center" mt={0}>
                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                options={tradeTypeOptions}
                                value={form.tradeType || null}
                                onChange={(_, v) => dispatch({ type: "SET", key: "tradeType", value: v || "" })}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Trade Type *"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        error={Boolean(errors.tradeType)}
                                        helperText={errors.tradeType || ""}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                options={incotermsOptions}
                                getOptionLabel={(o) => o?.label || ""}
                                value={form.incoterm ? { label: form.incoterm } : null}
                                onChange={(_, v) => dispatch({ type: "SET", key: "incoterm", value: v ? v.label : "" })}
                                isOptionEqualToValue={(opt, val) => opt.label === val.label}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Incoterm *"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        error={Boolean(errors.incoterm)}
                                        helperText={errors.incoterm || ""}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Commodity / Vertical"
                                value={form.commodityOrVertical}
                                onChange={(e) => dispatch({ type: "SET", key: "commodityOrVertical", value: e.target.value })}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>



                            {/* ORIGIN */}
                            <Grid item xs={12} md={6}>
                                <Typography variant="h6">Origin</Typography>

                                <Grid container spacing={2} mt={1}>
                                    <Grid item xs={12} sm={6}>
                                        <Autocomplete
                                            options={countryOptions}
                                            getOptionLabel={(o) => o.label}
                                            value={selectedOriginCountry || null}
                                            onChange={(_, newVal) => {
                                                setSelectedOriginCountry(newVal);
                                                setLeadData((p) => ({
                                                    ...p,
                                                    origin: { ...p.origin, country: newVal?.label || "" },
                                                }));
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} label="Origin Country" InputLabelProps={{ shrink: true }} />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Autocomplete
                                            options={originOptions}
                                            value={selectedOriginPlace || null}
                                            inputValue={originInputValue}
                                            loading={originLoading}
                                            onInputChange={(_, v) => setOriginInputValue(v)}
                                            onChange={(_, opt) => {
                                                setSelectedOriginPlace(opt);
                                                setLeadData((p) => ({
                                                    ...p,
                                                    origin: {
                                                        ...p.origin,
                                                        placeLabel: opt?.label || "",
                                                        placeType: opt?.type || "",
                                                        placeId: opt?.id || "",
                                                    },
                                                }));
                                            }}
                                            groupBy={(opt) => opt.type}
                                            getOptionLabel={(opt) => opt?.label || ""}
                                            isOptionEqualToValue={(o, v) => `${o?.type}-${o?.id}` === `${v?.type}-${v?.id}`}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Origin (Seaport / Airport / City)"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            {/* DESTINATION */}
                            <Grid item xs={12} md={6}>
                                <Typography variant="h6">Destination</Typography>

                                <Grid container spacing={2} mt={1}>
                                    <Grid item xs={12} sm={6}>
                                        <Autocomplete
                                            options={countryOptions}
                                            getOptionLabel={(o) => o.label}
                                            value={selectedDestinationCountry || null}
                                            onChange={(_, newVal) => {
                                                setSelectedDestinationCountry(newVal);
                                                setLeadData((p) => ({
                                                    ...p,
                                                    destination: { ...p.destination, country: newVal?.label || "" },
                                                }));
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} label="Destination Country" InputLabelProps={{ shrink: true }} />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Autocomplete
                                            options={destinationOptions}
                                            value={selectedDestinationPlace || null}
                                            inputValue={destinationInputValue}
                                            loading={destinationLoading}
                                            onInputChange={(_, v) => setDestinationInputValue(v)}
                                            onChange={(_, opt) => {
                                                setSelectedDestinationPlace(opt);
                                                setLeadData((p) => ({
                                                    ...p,
                                                    destination: {
                                                        ...p.destination,
                                                        placeLabel: opt?.label || "",
                                                        placeType: opt?.type || "",
                                                        placeId: opt?.id || "",
                                                    },
                                                }));
                                            }}
                                            groupBy={(opt) => opt.type}
                                            getOptionLabel={(opt) => opt?.label || ""}
                                            isOptionEqualToValue={(o, v) => `${o?.type}-${o?.id}` === `${v?.type}-${v?.id}`}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Destination (Seaport / Airport / City)"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                    </Grid>


                    {/* ✅ C) Product / Service Mode (Repeatable) */}
                    <MDBox mt={2}>
                        <MDTypography variant="h6">LEAD QUALIFICATION — PRODUCT / SERVICE MODE</MDTypography>
                    </MDBox>

                    {(form.productServiceModes || []).map((row, idx) => (
                        <MDBox key={idx} mt={1}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} sm={3}>
                                    <Autocomplete
                                        options={modeOptions}
                                        value={row.serviceMode || null}
                                        onChange={(_, v) => {
                                            const next = [...form.productServiceModes];
                                            next[idx] = {
                                                ...next[idx],
                                                serviceMode: v || "",
                                                // mode Project değilse subtype temizle
                                                projectSubtype: (v === "Project" ? next[idx].projectSubtype : ""),
                                            };
                                            dispatch({ type: "SET", key: "productServiceModes", value: next });
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Mode *"
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors?.productServiceModes?.[idx]?.serviceMode)}
                                                helperText={errors?.productServiceModes?.[idx]?.serviceMode || ""}
                                            />
                                        )}
                                    />
                                </Grid>

                                {row.serviceMode === "Project" && (
                                    <Grid item xs={12} sm={3}>
                                        <Autocomplete
                                            options={projectSubtypeOptions}
                                            value={row.projectSubtype || null}
                                            onChange={(_, v) => {
                                                const next = [...form.productServiceModes];
                                                next[idx] = { ...next[idx], projectSubtype: v || "" };
                                                dispatch({ type: "SET", key: "productServiceModes", value: next });
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Project Subtype *"
                                                    fullWidth
                                                    InputLabelProps={{ shrink: true }}
                                                    error={Boolean(errors?.productServiceModes?.[idx]?.projectSubtype)}
                                                    helperText={errors?.productServiceModes?.[idx]?.projectSubtype || ""}
                                                />
                                            )}
                                        />
                                    </Grid>
                                )}

                                <Grid item xs={12} sm={row.serviceMode === "Project" ? 5 : 8}>
                                    <TextField
                                        label="Volume Estimate (range accepted)"
                                        value={row.volumeEstimate}
                                        onChange={(e) => {
                                            const next = [...form.productServiceModes];
                                            next[idx] = { ...next[idx], volumeEstimate: e.target.value };
                                            dispatch({ type: "SET", key: "productServiceModes", value: next });
                                        }}
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        placeholder="e.g. 1-2 TEU / 5-10 tons / 10-20 shipments"
                                    />
                                </Grid>

                                {/* + / - (same style) */}
                                <Grid item xs={12} sm={1} display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
                                    {form.productServiceModes.length > 1 && (
                                        <Box
                                            onClick={() => {
                                                const next = form.productServiceModes.filter((_, i) => i !== idx);
                                                dispatch({ type: "SET", key: "productServiceModes", value: next });
                                            }}
                                            sx={{
                                                width: 28,
                                                height: 28,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "50%",
                                                backgroundColor: "#ffebee",
                                                color: "red",
                                                fontSize: 18,
                                                fontWeight: "bold",
                                                cursor: "pointer",
                                                transition: "all 0.2s ease",
                                                "&:hover": { backgroundColor: "#ffcdd2", transform: "scale(1.1)" },
                                            }}
                                        >
                                            −
                                        </Box>
                                    )}

                                    {idx === form.productServiceModes.length - 1 && (
                                        <Box
                                            onClick={() => {
                                                dispatch({
                                                    type: "SET",
                                                    key: "productServiceModes",
                                                    value: [
                                                        ...form.productServiceModes,
                                                        { serviceMode: "", projectSubtype: "", volumeEstimate: "" },
                                                    ],
                                                });
                                            }}
                                            sx={{
                                                width: 28,
                                                height: 28,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "50%",
                                                backgroundColor: "#e8f5e9",
                                                color: "green",
                                                fontSize: 18,
                                                fontWeight: "bold",
                                                cursor: "pointer",
                                                transition: "all 0.2s ease",
                                                "&:hover": { backgroundColor: "#c8e6c9", transform: "scale(1.1)" },
                                            }}
                                        >
                                            +
                                        </Box>
                                    )}
                                </Grid>
                            </Grid>
                        </MDBox>
                    ))}

                    {/* ✅ D) Status & Follow-up */}
                    <MDBox mt={2}>
                        <MDTypography variant="h6">LEAD QUALIFICATION — STATUS & FOLLOW-UP</MDTypography>
                    </MDBox>

                    <Grid container spacing={2} alignItems="center" mt={0}>
                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                options={leadStatusOptions}
                                value={form.leadStatus || null}
                                onChange={(_, v) => dispatch({ type: "SET", key: "leadStatus", value: v || "" })}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Lead Status *"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        error={Boolean(errors.leadStatus)}
                                        helperText={errors.leadStatus || ""}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                options={followUpPlanOptions}
                                value={form.followUpPlan || null}
                                onChange={(_, v) => dispatch({ type: "SET", key: "followUpPlan", value: v || "30" })}
                                renderInput={(params) => <TextField {...params} label="Follow-up Plan" fullWidth InputLabelProps={{ shrink: true }} />}
                            />
                        </Grid>

                        {form.followUpPlan === "custom" && (
                            <Grid item xs={12} sm={3}>
                                <TextField
                                    label="Custom Days"
                                    value={form.followUpCustomDays}
                                    onChange={(e) => dispatch({ type: "SET", key: "followUpCustomDays", value: e.target.value })}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    error={Boolean(errors.followUpCustomDays)}
                                    helperText={errors.followUpCustomDays || ""}
                                />
                            </Grid>
                        )}

                        <Grid item xs={12} sm={3}>
                            <TextField
                                type="date"
                                label="Next Action Date *"
                                value={formatDateInput(form.nextActionDate)}
                                onChange={(e) =>
                                    dispatch({ type: "SET", key: "nextActionDate", value: e.target.value ? new Date(e.target.value) : null })
                                }
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                error={Boolean(errors.nextActionDate)}
                                helperText={errors.nextActionDate || ""}
                            />

                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                options={actionTypeOptions}
                                value={form.nextActionType || null}
                                onChange={(_, v) => dispatch({ type: "SET", key: "nextActionType", value: v || "" })}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Next Action Type *"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        error={Boolean(errors.nextActionType)}
                                        helperText={errors.nextActionType || ""}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>



                    {/* ✅ SOURCE ROW */}
                    <Grid container spacing={2} alignItems="center" mt={1}>
                        <Grid item xs={12} sm={4}>
                            <Autocomplete
                                options={sourceTypeOptions}
                                value={form.sourceType || null}
                                onChange={(_, v) => dispatch({ type: "SET", key: "sourceType", value: v || "" })}
                                renderInput={(params) => <TextField {...params} label="Source Type" fullWidth InputLabelProps={{ shrink: true }} />}
                            />
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <MDTypography variant="caption" color="secondary">
                                Source Detail fields will appear based on Source Type.
                            </MDTypography>
                        </Grid>
                    </Grid>

                    {renderSourceDetailFields()}

                    <Grid container spacing={2} alignItems="center" mt={1}>
                        <Grid item xs={12} sm={6}>
                            <Autocomplete
                                multiple
                                options={salesRepOptions}
                                getOptionLabel={(option) => option.label}
                                value={form.salesRep}
                                onChange={(_, newValues) => dispatch({ type: "SET", key: "salesRep", value: newValues || [] })}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                renderInput={(params) => (
                                    <TextField {...params} label="Sales Representatives" InputLabelProps={{ shrink: true }} />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Autocomplete
                                multiple
                                options={salesRepOptions}
                                getOptionLabel={(option) => option.label}
                                value={form.attendees}
                                onChange={(_, newValues) => dispatch({ type: "SET", key: "attendees", value: newValues || [] })}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                renderInput={(params) => <TextField {...params} label="Attendees" InputLabelProps={{ shrink: true }} />}
                            />
                        </Grid>
                    </Grid>

                    <MDBox mt={2} sx={{ display: "flex", gap: 2, justifyContent: "flex-start", flexWrap: "wrap" }}>
                        <CrmActionButton
                            variant="secondary"
                            disabled={loading || !form.selectedCustomer}
                            onClick={handleCreateOpp}
                        >
                            Create Opportunities
                        </CrmActionButton>

                        {/* Normal submit butonu aynen kalsın */}
                        <form onSubmit={submitHandler}>
                            <CrmActionButton type="submit" disabled={loading}>
                                {isEditing ? "Update Sales Lead" : "Create Sales Lead"}
                            </CrmActionButton>
                        </form>
                    </MDBox>
                </MDBox>
            </MDBox>
            </ReadOnlyFieldset>

            <br />
            <Footer />
            <Snackbar
                open={snack.open}
                autoHideDuration={4000}
                onClose={closeSnack}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert onClose={closeSnack} severity={snack.severity} variant="filled" sx={{ width: "100%" }}>
                    {snack.message}
                </Alert>
            </Snackbar>

        </DashboardLayout>
    );
};

export default CreateSalesLead;
